import React from "react";

export const GiftIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6.66602 4.00013V12.6668M6.66602 4.00013C6.42487 3.0064 6.00965 2.15684 5.47451 1.56224C4.93937 0.967635 4.30914 0.65559 3.66602 0.666795C3.22399 0.666795 2.80007 0.84239 2.4875 1.15495C2.17494 1.46751 1.99935 1.89143 1.99935 2.33346C1.99935 2.77549 2.17494 3.19941 2.4875 3.51197C2.80007 3.82453 3.22399 4.00013 3.66602 4.00013M6.66602 4.00013C6.90717 3.0064 7.32238 2.15684 7.85753 1.56224C8.39267 0.967635 9.02289 0.65559 9.66602 0.666795C10.108 0.666795 10.532 0.84239 10.8445 1.15495C11.1571 1.46751 11.3327 1.89143 11.3327 2.33346C11.3327 2.77549 11.1571 3.19941 10.8445 3.51197C10.532 3.82453 10.108 4.00013 9.66602 4.00013M11.3327 6.6668V11.3335C11.3327 11.6871 11.1922 12.0262 10.9422 12.2763C10.6921 12.5263 10.353 12.6668 9.99935 12.6668H3.33268C2.97906 12.6668 2.63992 12.5263 2.38987 12.2763C2.13982 12.0262 1.99935 11.6871 1.99935 11.3335V6.6668M1.33268 4.00013H11.9993C12.3675 4.00013 12.666 4.29861 12.666 4.6668V6.00013C12.666 6.36832 12.3675 6.6668 11.9993 6.6668H1.33268C0.964492 6.6668 0.666016 6.36832 0.666016 6.00013V4.6668C0.666016 4.29861 0.964492 4.00013 1.33268 4.00013Z"
      stroke="#FCBD00"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6 9L12 15L18 9"
      stroke="rgba(255, 255, 255, 0.6)"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RaffleConditionDoneIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10.9987 20.1663C16.0613 20.1663 20.1654 16.0623 20.1654 10.9997C20.1654 5.93706 16.0613 1.83301 10.9987 1.83301C5.93609 1.83301 1.83203 5.93706 1.83203 10.9997C1.83203 16.0623 5.93609 20.1663 10.9987 20.1663Z"
      stroke="#3BC16B"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 10.9998L10.0833 12.8332L13.75 9.1665"
      stroke="#3BC16B"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RaffleConditionPendingIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10.9987 20.1663C16.0613 20.1663 20.1654 16.0623 20.1654 10.9997C20.1654 5.93706 16.0613 1.83301 10.9987 1.83301C5.93609 1.83301 1.83203 5.93706 1.83203 10.9997C1.83203 16.0623 5.93609 20.1663 10.9987 20.1663Z"
      stroke="#9A9AA3"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LockIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M22.1667 12.8335H5.83333C4.54467 12.8335 3.5 13.8782 3.5 15.1668V23.3335C3.5 24.6222 4.54467 25.6668 5.83333 25.6668H22.1667C23.4553 25.6668 24.5 24.6222 24.5 23.3335V15.1668C24.5 13.8782 23.4553 12.8335 22.1667 12.8335Z"
      stroke="white"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16797 12.833V8.16634C8.16797 6.61924 8.78255 5.13551 9.87651 4.04155C10.9705 2.94759 12.4542 2.33301 14.0013 2.33301C15.5484 2.33301 17.0321 2.94759 18.1261 4.04155C19.2201 5.13551 19.8346 6.61924 19.8346 8.16634V12.833"
      stroke="white"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RaffleInfoIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25ZM12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM13.5 15.75C13.5 16.5784 12.8284 17.25 12 17.25C11.1716 17.25 10.5 16.5784 10.5 15.75C10.5 14.9216 11.1716 14.25 12 14.25C12.8284 14.25 13.5 14.9216 13.5 15.75ZM13.125 7.5C13.125 6.87868 12.6213 6.375 12 6.375C11.3787 6.375 10.875 6.87868 10.875 7.5V11.25C10.875 11.8713 11.3787 12.375 12 12.375C12.6213 12.375 13.125 11.8713 13.125 11.25V7.5Z"
      fill="currentColor"
    />
  </svg>
);

export const RaffleCalendarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 5.49674C4.83579 5.49674 4.5 5.16095 4.5 4.74674V4.00001C3.67157 4.00001 3 4.67159 3 5.50001V6.50001H13V5.50001C13 4.67159 12.3284 4.00001 11.5 4.00001V4.75003C11.5 5.16425 11.1642 5.50003 10.75 5.50003C10.3358 5.50003 10 5.16425 10 4.75003V4.00001H6V4.74674C6 5.16095 5.66421 5.49674 5.25 5.49674ZM10 2.50001H6V1.74756C6 1.33334 5.66421 0.997559 5.25 0.997559C4.83579 0.997559 4.5 1.33334 4.5 1.74756V2.50001C2.84315 2.50001 1.5 3.84316 1.5 5.50001V11.5C1.5 13.1569 2.84315 14.5 4.5 14.5H11.5C13.1569 14.5 14.5 13.1569 14.5 11.5V5.50001C14.5 3.84316 13.1569 2.50001 11.5 2.50001V1.75001C11.5 1.3358 11.1642 1.00001 10.75 1.00001C10.3358 1.00001 10 1.3358 10 1.75001V2.50001ZM3 8.00001V11.5C3 12.3284 3.67157 13 4.5 13H11.5C12.3284 13 13 12.3284 13 11.5V8.00001H3Z"
      fill="#FCBD00"
    />
  </svg>
);

export const RaffleChanceIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.21967 2.71967C2.36032 2.57902 2.55109 2.5 2.75 2.5C2.94891 2.5 3.13968 2.57902 3.28033 2.71967L5.28033 4.71967C5.57322 5.01256 5.57322 5.48744 5.28033 5.78033C4.98744 6.07322 4.51256 6.07322 4.21967 5.78033L3.5 5.06066L3.5 12.75C3.5 13.1642 3.16421 13.5 2.75 13.5C2.33579 13.5 2 13.1642 2 12.75L2 5.06066L1.28033 5.78033C0.987437 6.07322 0.512563 6.07322 0.21967 5.78033C-0.0732232 5.48744 -0.0732232 5.01256 0.21967 4.71967L2.21967 2.71967ZM7.75 4C7.33579 4 7 3.66421 7 3.25C7 2.83579 7.33579 2.5 7.75 2.5H15.25C15.6642 2.5 16 2.83579 16 3.25C16 3.66421 15.6642 4 15.25 4H7.75ZM7.75 7.25C7.33579 7.25 7 7.58579 7 8C7 8.41421 7.33579 8.75 7.75 8.75H13.25C13.6642 8.75 14 8.41421 14 8C14 7.58579 13.6642 7.25 13.25 7.25H7.75ZM7.75 12C7.33579 12 7 12.3358 7 12.75C7 13.1642 7.33579 13.5 7.75 13.5H10.25C10.6642 13.5 11 13.1642 11 12.75C11 12.3358 10.6642 12 10.25 12H7.75Z"
      fill="#FCBD00"
    />
  </svg>
);

export const RaffleFairIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75362 5.87807L9.02869 3.34604C9.33182 3.20054 9.66376 3.125 10 3.125C10.3362 3.125 10.6682 3.20054 10.9713 3.34604L16.2464 5.87807C16.6306 6.0625 16.875 6.45092 16.875 6.8771V7.5C16.875 11.1442 15.0181 14.5373 11.9487 16.5017L10.7164 17.2904C10.5025 17.4273 10.2539 17.5 10 17.5C9.74608 17.5 9.49747 17.4273 9.2836 17.2904L8.05134 16.5017C4.98191 14.5373 3.125 11.1442 3.125 7.5V6.8771C3.125 6.45092 3.36941 6.0625 3.75362 5.87807ZM8.21732 1.65569L2.94225 4.18772C1.90795 4.68419 1.25 5.72981 1.25 6.8771V7.5C1.25 11.7836 3.43268 15.7719 7.04062 18.081L8.27287 18.8696C8.78848 19.1996 9.38783 19.375 10 19.375C10.6122 19.375 11.2115 19.1996 11.7271 18.8696L12.9594 18.081C16.5673 15.7719 18.75 11.7836 18.75 7.5V6.8771C18.75 5.72981 18.0921 4.68419 17.0577 4.18772L11.7827 1.65569C11.2263 1.38864 10.6171 1.25 10 1.25C9.38289 1.25 8.77366 1.38864 8.21732 1.65569ZM13.875 8.0625C14.1857 7.64828 14.1017 7.06066 13.6875 6.75C13.2733 6.43934 12.6857 6.52328 12.375 6.9375L9.27357 11.0727L7.53791 9.33709C7.17179 8.97097 6.5782 8.97097 6.21209 9.33709C5.84597 9.7032 5.84597 10.2968 6.21209 10.6629L8.71209 13.1629C8.90426 13.3551 9.17037 13.4544 9.44146 13.4351C9.71255 13.4159 9.96194 13.2799 10.125 13.0625L13.875 8.0625Z"
      fill="#3BC16B"
    />
  </svg>
);

export const RaffleModalCloseIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="25" height="25" rx="12.5" fill="black" fillOpacity="0.45" />
    <path
      d="M8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289C8.68342 7.90237 9.31658 7.90237 9.70711 8.29289L16.7782 15.364C17.1687 15.7545 17.1687 16.3877 16.7782 16.7782C16.3877 17.1687 15.7545 17.1687 15.364 16.7782L8.29289 9.70711Z"
      fill="white"
    />
    <path
      d="M9.7072 16.7782C9.31668 17.1688 8.68351 17.1688 8.29299 16.7782C7.90246 16.3877 7.90246 15.7546 8.29299 15.364L15.3641 8.29296C15.7546 7.90244 16.3877 7.90244 16.7783 8.29296C17.1688 8.68349 17.1688 9.31665 16.7783 9.70718L9.7072 16.7782Z"
      fill="white"
    />
  </svg>
);

export const RaffleHistoryIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M0.75 7.5C0.75 8.83502 1.14588 10.1401 1.88758 11.2501C2.62928 12.3601 3.68349 13.2253 4.91689 13.7362C6.15029 14.2471 7.50749 14.3808 8.81686 14.1203C10.1262 13.8599 11.329 13.217 12.273 12.273C13.217 11.329 13.8599 10.1262 14.1203 8.81686C14.3808 7.50749 14.2471 6.15029 13.7362 4.91689C13.2253 3.68349 12.3601 2.62928 11.2501 1.88758C10.1401 1.14588 8.83502 0.75 7.5 0.75C5.61296 0.757099 3.80173 1.49342 2.445 2.805L0.75 4.5M0.9375 0.9375V4.58333H4.58333M7.5 3.85417V7.5L10.4167 8.95834"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RaffleChevronRightIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6.75 13.5L11.25 9L6.75 4.5"
      stroke="#9A9AA3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RaffleHistoryBackIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M22.25 15.5L17.75 20L22.25 24.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RafflePrizeIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M5.83398 8.55176V9.50026C5.83178 9.70012 5.77827 9.89607 5.67857 10.0693C5.57888 10.2425 5.43635 10.3873 5.26465 10.4896C4.90015 10.7596 4.60364 11.1108 4.39868 11.5155C4.19373 11.9201 4.08597 12.367 4.08398 12.8206"
      stroke="#3BC16B"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16602 8.55176V9.50026C8.16822 9.70012 8.22173 9.89607 8.32143 10.0693C8.42112 10.2425 8.56365 10.3873 8.73535 10.4896C9.09985 10.7596 9.39636 11.1108 9.60132 11.5155C9.80627 11.9201 9.91403 12.367 9.91602 12.8206"
      stroke="#3BC16B"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 5.25016H11.375C11.7618 5.25016 12.1327 5.09652 12.4062 4.82303C12.6797 4.54954 12.8333 4.1786 12.8333 3.79183C12.8333 3.40506 12.6797 3.03412 12.4062 2.76063C12.1327 2.48714 11.7618 2.3335 11.375 2.3335H10.5"
      stroke="#3BC16B"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33398 12.8335H11.6673"
      stroke="#3BC16B"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 5.24984C3.5 6.17809 3.86875 7.06833 4.52513 7.72471C5.1815 8.38109 6.07174 8.74984 7 8.74984C7.92826 8.74984 8.8185 8.38109 9.47487 7.72471C10.1313 7.06833 10.5 6.17809 10.5 5.24984V1.74984C10.5 1.59513 10.4385 1.44675 10.3291 1.33736C10.2197 1.22796 10.0714 1.1665 9.91667 1.1665H4.08333C3.92862 1.1665 3.78025 1.22796 3.67085 1.33736C3.56146 1.44675 3.5 1.59513 3.5 1.74984V5.24984Z"
      stroke="#3BC16B"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.49935 5.25016H2.62435C2.23757 5.25016 1.86664 5.09652 1.59315 4.82303C1.31966 4.54954 1.16602 4.1786 1.16602 3.79183C1.16602 3.40506 1.31966 3.03412 1.59315 2.76063C1.86664 2.48714 2.23757 2.3335 2.62435 2.3335H3.49935"
      stroke="#3BC16B"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
